import { useState } from "react";
import { format, parse } from "date-fns";
import { CalendarDays, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

const DROPDOWN_CLS = {
  caption: "flex justify-center pt-1 relative items-center px-9",
  caption_dropdowns: "flex gap-2 justify-center",
  dropdown_month: "relative inline-flex items-center",
  dropdown_year: "relative inline-flex items-center",
  dropdown: "absolute inset-0 w-full cursor-pointer opacity-0 z-10",
  caption_label: "inline-flex items-center gap-1 rounded-md border px-2 py-1 text-sm font-medium",
  vhidden: "sr-only",
};

// value/onChange use "YYYY-MM-DD" strings
export function DateField({ value, onChange, placeholder = "Pick a date", min, max, dropdown, className, testId }) {
  const [open, setOpen] = useState(false);
  const toDate = (s) => (s ? parse(s, "yyyy-MM-dd", new Date()) : undefined);
  const sel = toDate(value);
  const lo = toDate(min), hi = toDate(max);
  return (
    <div className={cn("relative flex items-center", className)}>
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" className={cn("w-full justify-start font-normal", !sel && "text-muted-foreground")} data-testid={testId}>
          <CalendarDays className="h-4 w-4 mr-2" />{sel ? format(sel, "dd MMM yyyy") : placeholder}
        </Button>
      </PopoverTrigger>
      {sel && <button type="button" className="-ml-8 relative z-10 rounded-full p-1 text-[#5B6B79] hover:text-red-700" onClick={() => onChange("")} aria-label="Clear date" data-testid={testId && `${testId}-clear`}><X className="h-3.5 w-3.5" /></button>}
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar mode="single" selected={sel} defaultMonth={sel || hi} initialFocus
          {...(dropdown ? { captionLayout: "dropdown-buttons", fromYear: 1920, toYear: new Date().getFullYear(), classNames: DROPDOWN_CLS } : {})}
          disabled={[...(lo ? [{ before: lo }] : []), ...(hi ? [{ after: hi }] : [])]}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} data-testid={testId && `${testId}-calendar`} />
      </PopoverContent>
    </Popover>
    </div>
  );
}
